import React from 'react';
import styled from 'styled-components';
//
import colors from 'theme/colors';
import DealManagement from 'components/sidebar/deal-management';
import { IFormulaEntryState, EFormulaModalType } from 'store/formula-entry/types';
import { ISidebarState } from 'store/sidebar/types';

// Modals
import AdditionalBatnasModal from 'components/formula-entry/modals/additional-batnas';
import BaseBatnaModal from 'components/formula-entry/modals/base-batna';
import CapOptionModal from 'components/formula-entry/modals/cap-option';
import FloorOptionModal from 'components/formula-entry/modals/floor-option';
import PushOptionModal from 'components/formula-entry/modals/push-option';
import PullOptionModal from 'components/formula-entry/modals/pull-option';
import ContractTermOptionModal from 'components/formula-entry/modals/contract-term-option';
import CostsModal from 'components/formula-entry/modals/costs';
import FormulaListModal from 'components/formula-entry/modals/formula-list';

const { darkBorder } = colors;

const Sidebar = styled.div`
  min-height: calc(100vh - 56px);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  z-index: 2;

  hr {
    border-top: 1px solid ${darkBorder};
  }
`;

const DealManagementContainer = styled.div`
  display: flex;
  flex-direction: row;
  position: sticky;
  top: 59px;
  overflow: hidden;
`;

interface IProps {
  formulaEntry: IFormulaEntryState;
  sidebar: ISidebarState;
}

export default ({ formulaEntry, sidebar }: IProps) => {
  const { modalType } = formulaEntry;
  const { visible } = sidebar;

  function renderModal() {
    switch (modalType) {
      case null: {
        return null;
      }

      case EFormulaModalType.ADDITIONAL_BATNAS: {
        return <AdditionalBatnasModal />;
      }

      case EFormulaModalType.BASE_BATNA: {
        return <BaseBatnaModal />;
      }

      case EFormulaModalType.CAP: {
        return <CapOptionModal />;
      }

      case EFormulaModalType.FLOOR: {
        return <FloorOptionModal />;
      }

      case EFormulaModalType.PUSH: {
        return <PushOptionModal />;
      }

      case EFormulaModalType.PULL: {
        return <PullOptionModal />;
      }

      case EFormulaModalType.CONTRACT_TERM: {
        return <ContractTermOptionModal />;
      }

      case EFormulaModalType.COSTS: {
        return <CostsModal />;
      }
      case EFormulaModalType.FORMULA_LIST: {
        return <FormulaListModal />;
      }

      default: {
        return null;
      }
    }
  }

  return (
    <Sidebar>
      {visible ? (
        <DealManagementContainer>
          <DealManagement />
          {renderModal()}
        </DealManagementContainer>
      ) : null}
    </Sidebar>
  );
};
